import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Container, Button } from "reactstrap";
import { AppContext } from "../../context/app-context";
import DietPlanCard from './component/DietPlanCard';
import HowThisWorks from './component/HowThisWorks';
import PlanHighlights from './component/PlanHighlights';
import DietHeader from './DietHeader';
import { useDiet } from '../../hooks/useDiet';
import API from '../../helper/API';
import { sendFirebaseEvent } from '../../helper/mobile';

const DietPlanDetail = () => {

  const { type } = useParams();
  let navigate = useNavigate();
  const [state, dispatch] = useContext(AppContext);
  const { makeDietPayment } = useDiet();

  const [dietPlan, setDietPlan] = useState();

  useEffect(() => {
    setDietPlan(state.dietPlans.find(obj => obj.dietPlanType === type));
  }, []);

  const onClickHandler = () => {
    const request = {
      "userId":state.user.userId,
      "groupId":state.user.groupId,
      "appVersion":state.user.appVersion,
      "osType":state.user.osType,
      "dietPlanType":dietPlan.dietPlanType
    }

    sendFirebaseEvent('diet_plan_make_payment_click', 'click_event', dietPlan.dietPlanType);
    API.get(`/user/dietplan/?userId=${state.user.userId}`).then(response => {
      if(response?.data?.dietPlanType) {
        navigate(`/diet/${response.data.dietPlanType}/${response.data.dietPlanId}/assessment/${state.user.isGoalSet === 'true' ? 'planType' : 'healthConditions'}`);
      }
    }).catch(error => {
      makeDietPayment(request);
      console.log("Error", error);
    })

  }

  return(
    <div>
      <DietHeader planType={type} />
      <Container className="diet-container mb-6-rem">
        {
          dietPlan &&
          <>
            <DietPlanCard dietPlan={dietPlan} />
            <PlanHighlights dietPlan={dietPlan} />
            <HowThisWorks dietPlan={dietPlan} />
          </>
        }
        {
          type === 'one_month_smart_diet_plan' ? <div className="floating-btn-div"><Button className='diet-payment-btn' onClick={onClickHandler}>Get started</Button></div> :
            <div className="floating-btn-div">
              <Link to={`selectDevice`}>
                <Button className='diet-payment-btn'>Next: Select your devices</Button>
              </Link>
            </div>
        }
      </Container>
    </div>
  );
}

export default DietPlanDetail;